import { Box } from '@chakra-ui/react';
import { useSelectIsL2Visible } from 'Deer/slice/DeerNav.slice';
import { checkNewNavEnabled } from 'utils/helpers/featureFlags';

import { isNetchexLogin } from 'constants/netChexConstants';

export const HeaderMarginContainer = ({ children, wrapperProps = {} }) => {
  const isL2NavVisible = useSelectIsL2Visible();

  if (!checkNewNavEnabled()) {
    return <Box {...wrapperProps}>{children}</Box>;
  }

  return (
    <Box ml={isL2NavVisible || isNetchexLogin ? '0' : '34px'} transition="margin .3s ease;" {...wrapperProps}>
      {children}
    </Box>
  );
};
